<template>
	<b-row>
		<b-col>
			<b-card class="">
				<div slot="header">
					<b-form-radio-group
					id="btn-radios-2"
					v-model="selected"
					:options="options"
					class="ml-3"
					buttons
					button-variant="outline-primary"
					size="sm"
					name="radio-btn-outline"
					style="white-space: nowrap;"
					></b-form-radio-group>

					<div class="card-header-actions">
						<b-link
							@click="filterPage"
							class="card-header-action btn-setting"
							style="font-size: 15px">
							<i class="fa fa-search"></i>
						</b-link>
					</div>
				</div>
				<!-- Filter -->
					<b-row class="pt-2"  v-if="isFilterOpen">
						<b-col cols="3">
							<b-form>
								<multiselect
									v-model="depId"
									:options="myDepartments"
									:multiple="true"
									track-by="id"
									:show-labels="false"
									:allow-empty="true"
									label="name"
									:placeholder="$t('promo-to-product.department')"
									class="multiselect-pricing"
								>
								</multiselect>
							</b-form>
						</b-col>

							<b-col cols="3">
							<b-form>
							<multiselect
								:multiple="true"
								:show-labels="false"
								track-by="id"
								:custom-label="contragentSelectedOption"
								v-model="contragentIds"
								:options="contragents"
								:placeholder="$t('incomeFilter.contragent')"
								:searchable="true"
								>
							</multiselect>
							</b-form>
						</b-col>
						<div class="col-3">
							<b-form-group
								breakpoint="lg"
								label-size="sm"
								label-for="fromDate"
								class="required"
								size="sm"
							>
								<date-picker
								class="s"
								style="width:100%;"
								 v-model="search.startDate"
								lang="ru"
								:placeholder="$t('promo-to-product.start-date')"
								valueType="format"
								format="DD-MM-YYYY"></date-picker>
							</b-form-group>
						</div>
						<div class="col-3">
							<b-form-group
								breakpoint="lg"
								label-size="sm"
								label-for="fromDate"
								class="required"
								size="sm"
							>
								<date-picker
								class="s"
								style="width:100%;"
								 v-model="search.endDate"
								lang="ru"
								:placeholder="$t('promo-to-product.finish-date')"
								valueType="format"
								format="DD-MM-YYYY"></date-picker>
							</b-form-group>
						</div>
						<div class="col-3 mb-2">
							<b-form @submit="e => e.preventDefault()">
								<b-input-group>
								<b-form-input v-model="search.regNumber"
								 v-on:keyup.enter="fetchOrdersList" size="sm"
								:placeholder="$t('incomes.name')"/>
							</b-input-group>
							</b-form>
						</div>
						<div class="col-1 ">
							<b-button class="pt-2 pb-2" @click="fetchOrdersList" block variant="primary" size="sm">
								<i class="fa fa-search"></i>
								{{$t('contragent.filter')}}
							</b-button>
						</div>
					</b-row>
				<!-- //Filter end -->

				<div class="table-responsive table-wrapper">
					<b-table
					:items="ordersListManagerPage" class="generalTableClass"
							 :hover="hover" :striped="striped" :bordered="bordered"
							 :small="small"
							 :fixed="fixed"
							 :fields="fieldsForSended"
							 responsive="sm">
						<template slot="id" slot-scope="data">
							<strong>  {{ paginate(data.index, page, search.limit) }}</strong>
						</template>
						<template slot="status" slot-scope="data">
							<div class="p-1 text-center">
								<span v-if="data.item.status == 'PENDING'"
								class="bg-success p-1">
								{{data.item.status}}</span>
								<span v-if="data.item.status == 'SUSPEND'"
								class="bg-warning p-1">
								{{data.item.status}}</span>
								<span v-if="data.item.status == 'ONPROCESS'"
								class="bg-primary p-1">
								{{data.item.status}}</span>
								<span v-if="data.item.status == 'ARXIV'"
								class="bg-danger p-1">
								{{data.item.status}}</span>
							</div>
						</template>
						<template slot="actions" slot-scope="data">
							<b-link v-if="data.item.status == 'SUSPEND'" @click="editRequest(data.item.id)">
								<i class="fa fa-edit"></i>
							</b-link>
							<b-link v-if="selected == 'new' ||selected == 'finished'" @click="viewList(data.item.id)">
								<i class="fa fa-eye
								"></i>
							</b-link>
							<b-link v-if="selected == 'working'" @click="editOrder(data.item.id)">
								<i class="fa fa-edit
								"></i>
							</b-link>
						</template>
					</b-table>


					 <nav>
						<b-pagination :total-rows="totalOrderManagerPage" :per-page="search.limit"
							v-model="page"
							:prev-text="$t('pagination.prev')"
							:next-text="$t('pagination.next')"
							hide-goto-end-buttons/>
					</nav>
				</div>
			</b-card>
		</b-col>
	</b-row>
</template>

<script>
	import WhDocument from "../../services/wh-document.service";
	import {TokenService} from "../../services/storage.service";
	import {mapState, mapActions, mapGetters} from 'vuex'
	import Multiselect from 'vue-multiselect'
	import MaskedInput from 'vue-masked-input'
    import ContrAgentService from '../../services/contragent.service';
	export default {
		name: "RequestItems",
		components: {Multiselect, MaskedInput},
		props: {
			caption: {
				type: String,
				default: 'RequestTransfer'
			},
			hover: {
				type: Boolean,
				default: true
			},
			striped: {
				type: Boolean,
				default: true
			},
			bordered: {
				type: Boolean,
				default: false
			},
			small: {
				type: Boolean,
				default: false
			},
			fixed: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				docId:null,
				openModal:false,
				isFilterOpen:false,
				search: {
					limit: 20,
					startDate: null,
					endDate:null,
					regNumber: null,
					depId: [],
					contragentIds:[]
				},
				contragentIds: [],
				depId: [],
				items: [],
				total: 0,
				sidebarOpen: false,
				options: [
					{	text: this.$t('contragent_orders.working-on'), value: 'working'},
					{	text: this.$t('contragent_orders.new-orders'), value: 'new'},
					{	text: this.$t('contragent_orders.finished'), value: 'finished'},
				],

			}
		},

		methods: {
			...mapActions('departments', [
				'fetchMyDepartments', 'updateOrCreateChildDep', 'deleteDep'
			]),
			...mapActions('contragents', ['getOrdersListForManager','fetchContragents']),
			paginate(index, page_size, page_number) {
				--page_size;
				return (page_number * page_size) + index + 1;
			},
			filterPage() {
				this.isFilterOpen = !this.isFilterOpen
			},
			contragentSelectedOption (contragent) {
				return contragent.fullName
			},
			cancel() {
				this.openModal = false
				this.docId =null
			},
			async ok() {
				await ContrAgentService.receiveManager(this.docId)
			},
			async viewList(id) {
				await this.$router.push({name:'Order-view', params:{id:id}})
			},
			async editOrder(id) {
				await this.$router.push({name:'Order-control', params:{id:id}})
			},
			async fetchOrdersList() {
				this.search.page = this.page
				if(this.depId.length > 0) {
					this.search.depId = this.depId.map(el => el.id)
				}else {
					this.search.depId = []
				}
				if(this.contragentIds.length > 0) {
					this.search.contragentIds = this.contragentIds.map(el => el.id)
				}else {
					this.search.contragentIds= []
				}
				if(this.search.endDate == "" || this.search.startDate == ""){
					this.search.startDate = null
					this.search.endDate = null
				}

				await this.getOrdersListForManager({search:this.search,selected: this.selected})
			}
		},
		computed: {
			...mapState(['isCashier','isContragent', 'isAdmin', 'userName', 'isMonitoring']),
			...mapState('contragents', ['ordersListManagerPage','totalOrderManagerPage','contragents',
			'pageStore','selectedStore']),
			...mapGetters('departments', [
				'myDepartments'
			]),
			page: {
				get() {
					return this.pageStore
				},
				async set(value) {
					await this.$store.commit('contragents/setValuePageStore',value)
					await this.fetchOrdersList()
				}
			},
			selected: {
				get() {
					return this.selectedStore
				},
				async set(value) {
					await this.$store.commit('contragents/setValueSelectedStore',value)
					await this.fetchOrdersList()
				}
			},
			managerId() {
				return TokenService.getCurrentUserId();
			},
			fieldsForSended() {
				return [
					{
						key: 'id',
						label: 'ID',
						'class': 'role_id',
					},
					{
						key: 'regDate',
						label: this.$t('pricing.costDate'),
					},
					{
						key: 'regNumber',
						label: this.$t('pricing.costNumber'),
					},
					{
						key: 'status',
						label: this.$t('sale.status'),
					},
					{
						key: 'fromContragentName',
						label: this.$t('incomes.fromDepartment')
					},
					{
						key: 'departmentName',
						label: this.$t('incomes.toDepartment')
					},
					{
						key: 'managerName',
						label:"MANAGER",
					},
					{
						key: 'comment',
						label: this.$t('comment'),
					},
					{
						key: 'actions',
						'class': 'table_actions',
						label: this.$t('prices.item.actions'),
					},
				]
			},
		},
		async created() {
			await this.$store.commit('contragents/setContragentName',null)
			await this.fetchContragents()
			await this.fetchMyDepartments();
			await this.fetchOrdersList()
		},
	}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
// .s {
// 	.mx-input {
// 		height: 31px !important;
// 	}
// }
</style>
